import React from 'react'
import Contactpage from '../components/Contactpage/Contactpage';


function Contact() {
  return (
    <div clas>
      <Contactpage/>         
      
      
    </div>
  )
}

export default Contact;
